"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../common/common");

function mockUseEffect(sandbox, reactLibrary, effectCount) {
  var currentEffect = 0;
  var renderCount = 0;
  var allEffectDeps = [];
  var tidyUpCallbacks = [];

  var cleanUpAll = function cleanUpAll() {
    return tidyUpCallbacks.forEach(function (tidyUpCallback) {
      return tidyUpCallback && tidyUpCallback();
    });
  };

  var cleanUp = function cleanUp(index) {
    var tidyUpCallback = tidyUpCallbacks[index];

    if (tidyUpCallback) {
      tidyUpCallback();
    }
  };

  var effectStub = sandbox.stub(reactLibrary, "useEffect").callsFake(function (setupCallback, deps) {
    var previousDeps = allEffectDeps[currentEffect];
    var tidyUpCallback = tidyUpCallbacks[currentEffect];
    var changedDep = previousDeps ? (deps === null || deps === void 0 ? void 0 : deps.find(function (dep, i) {
      return previousDeps[i] !== dep;
    })) !== undefined : true;

    if (changedDep) {
      allEffectDeps[currentEffect] = deps || [];
      tidyUpCallbacks[currentEffect] = setupCallback();

      if (tidyUpCallback) {
        tidyUpCallback();
      }
    }

    currentEffect++;

    if (currentEffect === effectCount) {
      renderCount++;
      currentEffect = 0;
    }
  });
  effectStub.cleanUpAll = cleanUpAll;
  effectStub.cleanUp = cleanUp;
  return effectStub;
}

exports.mockUseEffect = mockUseEffect;

function mockUseRef(sandbox, reactLibrary, refCount) {
  var generatedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var allRefs = [];
  var i = 0;
  var renderCount = 0;
  return sandbox.stub(reactLibrary, "useRef").callsFake(function (initialValue) {
    var currentRef = allRefs[i];

    if (!currentRef) {
      var current = common_1.isDefined(initialValue) ? initialValue : generatedValue[i];
      currentRef = {
        current: current
      };
      allRefs[i] = currentRef;
    }

    i++;

    if (i === refCount) {
      renderCount++;
      i = 0;
    }

    return currentRef;
  });
}

exports.mockUseRef = mockUseRef;